import { createTheme } from "@mui/material";

import { getMuiAvatar } from "./overrides/MuiAvatar";
import { getMuiButton } from "./overrides/MuiButton";
import { getMuiCheckbox } from "./overrides/MuiCheckbox";
import { getMuiCircularProgress } from "./overrides/MuiCircularProgress";
import { getMuiDialog } from "./overrides/MuiDialog";
import { getMuiDialogActions } from "./overrides/MuiDialogActions";
import { getMuiDialogContent } from "./overrides/MuiDialogContent";
import { getMuiDialogTitle } from "./overrides/MuiDialogTitle";
import { getMuiFormHelperText } from "./overrides/MuiFormHelperText";
import { getMuiList } from "./overrides/MuiList";
import { getMuiListItemAvatar } from "./overrides/MuiListItemAvatar";
import { getMuiListItemButton } from "./overrides/MuiListItemButton";
import { getMuiListItemIcon } from "./overrides/MuiListItemIcon";
import { getMuiListItemText } from "./overrides/MuiListItemText";
import { getMuiMenu } from "./overrides/MuiMenu";
import { getMuiMenuItem } from "./overrides/MuiMenuItem";
import { getMuiSelect } from "./overrides/MuiSelect";
import { getMuiSkeleton } from "./overrides/MuiSkeleton";
import { getMuiSvgIcon } from "./overrides/MuiSvgIcon";
import { getMuiSwitch } from "./overrides/MuiSwitch";
import { getMuiTab } from "./overrides/MuiTab";
import { getMuiTable } from "./overrides/MuiTable";
import { getMuiTableCell } from "./overrides/MuiTableCell";
import { getMuiTablePagination } from "./overrides/MuiTablePagination";
import { getMuiTableRow } from "./overrides/MuiTableRow";
import { getMuiTextField } from "./overrides/MuiTextField";
import { getMuiTooltip } from "./overrides/MuiTooltip";
import { getMuiTypography } from "./overrides/MuiTypography";
import { base } from "./theme.base";

export const theme = createTheme(base, {
  components: {
    ...getMuiAvatar(base),
    ...getMuiButton(base),
    ...getMuiCheckbox(base),
    ...getMuiCircularProgress(base),
    ...getMuiDialog(base),
    ...getMuiDialogActions(base),
    ...getMuiDialogContent(base),
    ...getMuiDialogTitle(base),
    ...getMuiFormHelperText(base),
    ...getMuiList(base),
    ...getMuiListItemAvatar(base),
    ...getMuiListItemButton(base),
    ...getMuiListItemIcon(base),
    ...getMuiListItemText(base),
    ...getMuiMenu(base),
    ...getMuiMenuItem(base),
    ...getMuiSelect(base),
    ...getMuiSkeleton(base),
    ...getMuiSvgIcon(base),
    ...getMuiSwitch(base),
    ...getMuiTab(base),
    ...getMuiTable(base),
    ...getMuiTableCell(base),
    ...getMuiTablePagination(base),
    ...getMuiTableRow(base),
    ...getMuiTextField(base),
    ...getMuiTooltip(base),
    ...getMuiTypography(base),
  },
  palette: {
    background: {
      default: base.palette.brand.white[200].main,
      paper: base.palette.brand.white[200].main,
    },
    error: {
      main: base.palette.brand.red[300].main,
    },
    info: {
      main: base.palette.brand.purple[300].main,
    },
    primary: {
      contrastText: base.palette.brand.white[100].main,
      dark: base.palette.brand.blue[300].dark,
      main: base.palette.brand.blue[300].main,
    },
    secondary: {
      main: base.palette.brand.orange[300].main,
    },
    success: {
      main: base.palette.brand.green[300].main,
    },
    warning: {
      main: base.palette.brand.yellow[300].main,
    },
  },
});
